import { Pipe, PipeTransform } from '@angular/core';
import { isExpired, type Timestamp } from '@context/shared/types/common';

/**
 * Pipe to check if a timestamp has expired (current time is past the timestamp).
 * Works with Firestore Timestamp objects or native Date objects.
 *
 * @example
 * ```html
 * @if (revision.expiresAt | isExpired) {
 *   <span>Expired</span>
 * }
 * ```
 */
@Pipe({
	name: 'isExpired',
	standalone: true,
})
export class IsExpiredPipe implements PipeTransform {
	transform(value: Timestamp | Date | null | undefined): boolean {
		return isExpired(value);
	}
}
